import { render, staticRenderFns } from "./rescrutinyStdList.vue?vue&type=template&id=77965e06&scoped=true&"
import script from "./rescrutinyStdList.vue?vue&type=script&lang=js&"
export * from "./rescrutinyStdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77965e06",
  null
  
)

export default component.exports